<div class="background">
  <!-- <img src="/public/images/background-image-3.jpg">
  <video loop muted autoplay oncanplay="this.play()" onloadedmetadata="this.muted = true">
    <source src="/public/images/3163534-uhd_2560_1440_30fps-576.mp4" media="(max-width: 576px)">
    <source src="/public/images/3163534-uhd_2560_1440_30fps-960.mp4" media="(min-width: 577px) and (max-width: 960px)">
    <source src="/public/images/3163534-uhd_2560_1440_30fps-1440.mp4" media="(min-width: 961px) and (max-width: 1440px)">
    <source src="/public/images/3163534-uhd_2560_1440_30fps-1920.mp4" media="(min-width: 1441px)">
    Your browser does not support the video tag.
  </video>-->
</div>

<div class="container">
  <div class="row row-responsive">

    <div class="offset-md-2 col-md-8 d-flex align-items-center text-center white-text">
      <h1><strong>{{'upload.upload-label' | translate}} </strong> {{'upload.header2' | translate}} <strong>{{creatorName}}</strong></h1>
    </div>

    <div class="col-md-12 position-relative">
      <div class="upload-container">   

        <mat-card class="upload-card fade-up">
          <mat-card-content>
            <app-dropzone [enabled]="dropZoneEnabled" #dropzone (fileChanged)="onFileChange($event)"></app-dropzone>
          </mat-card-content>
        </mat-card>
      
      <!--
        @if (selectedFiles.length === 0) {
          <div class="white-text">
            
            <div class="lead">
              <p>{{selectedFiles}}</p>
                <ul class="list-unstyled">
                  <li>
                      <i class="fa-solid fa-circle-check" ></i>
                      <span>{{'upload.check1' | translate }}</span>
                  </li>
                  <li>
                    <i class="fa-solid fa-circle-check" ></i>
                    <span>{{'upload.check2' | translate }}</span>
                  </li>
                  <li>
                    <i class="fa-solid fa-circle-check" ></i>
                    <span>{{'upload.check3' | translate }}</span>
                  </li>
                </ul>
                <br/>
              <a href="" class="button">{{'upload.link' | translate}}</a>
            </div>
          </div> 
        }
      -->
    @if (allFiles.length > 0) {
      <mat-card class="pl-0 w-100 min-height-100 files-card file-download-card">
        <mat-card-header>
          <h6>{{'upload.header3' | translate}} <!-- &nbsp; <i class="fa-solid fa-folder-open" style="font-size:20px;color:#FFCE00;"></i> {{folderName}} --></h6>
        </mat-card-header>
        <mat-card-content>
              <mat-list>
                @for (file of allFiles; track file) {
                <mat-list-item>
                  <span matListItemIcon>
                    @if (file.fileUploadStatus === FileUploadStatus.NotStarted) {
                      <i class="fa-solid fa-circle" aria-hidden="false" aria-label="Niet geupload" color="primary"></i>
                    }
                    @if (file.fileUploadStatus === FileUploadStatus.Uploading || file.fileUploadStatus === FileUploadStatus.Validating) {
                      <i class="fa-solid fa-hourglass-half" aria-hidden="false" aria-label="Bezig met uploaden" color="primary"></i>
                    }
                    @if (file.fileUploadStatus === FileUploadStatus.Uploaded) {
                      <i class="fa-solid fa-circle-check" aria-hidden="false" aria-label="Geupload" color="success"></i>
                    }
                  </span>
                  <span matListItemTitle>
                    <span>
                      {{ file.name }}
                    </span>
                    <span matListItemLine>
                      <span>
                        @if (file.fileUploadStatus === FileUploadStatus.NotStarted) {
                        {{ file.size | fileSize }}
                        }
                        @if (file.fileUploadStatus === FileUploadStatus.Uploading) {
                        {{ file.size | fileSize }}&nbsp;({{ file.progressPercentage }}%)
                        }
                        @if (file.fileUploadStatus === FileUploadStatus.Validating) {
                        {{ file.size | fileSize }}&nbsp;{{'upload.validate' | translate}}
                        }
                        @if (file.fileUploadStatus === FileUploadStatus.Uploaded) {
                        {{ file.size | fileSize }}&nbsp;{{'upload.upload' | translate}}
                        }
                      </span>
                      @if (file.createdDateTime) {
                      <span>&nbsp;-&nbsp;{{
                      file.createdDateTime | date:'d MMM HH:mm' }}</span>
                      }
                      <span>
                      </span>
                    </span>
                  </span>
                </mat-list-item>
                @if (file.fileUploadStatus === FileUploadStatus.Uploading) {
                <mat-list-item>
                  <mat-progress-bar mode="determinate" [value]="file.progressPercentage"></mat-progress-bar>
                </mat-list-item>
                }
                @if (file.fileUploadStatus === FileUploadStatus.Validating) {
                <mat-list-item>
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </mat-list-item>
                }
                }
              </mat-list>
              <div class="mt-1">

                @if (generalUploadStatus === GeneralUploadStatus.NotStarted) {
                  <a href="#" (click)="clearSelection($event)">{{'upload.deleteAll' | translate}}</a>
                }
                
                <!--
                @if (generalUploadStatus === GeneralUploadStatus.Uploaded) {
                  <a href="#" (click)="clearSelection($event)">{{'upload.startOver' | translate }}</a>
                }-->
              </div>
            </mat-card-content>
          </mat-card>
    }
  </div>
  </div>
